import { Component } from '@angular/core';
import { UmssSkeletonComponent } from '../skeleton/skeleton.component';

@Component({
  selector: 'umss-page-skeleton',
  imports: [UmssSkeletonComponent],
  templateUrl: './page-skeleton.component.html',
  styleUrl: './page-skeleton.component.scss'
})
export class PageSkeletonComponent {}
